import policyDetailsView from 'text!../policyDetails/policyDetails.html';
import policyDetailsCtrl from '../policyDetails/policyDetailsCtrl';
import quoteView from 'text!../quote/quote.html';
import quoteCtrl from '../quote/quoteCtrl';
import paymentDetailsView from 'text!../paymentsDetails/paymentsDetails.html';
import buildingsAndLocationsView from 'text!../buildingsAndLocations/buildingsAndLocations.html';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        pcCpPolicyDetails: {
            parent: wizardParentState,
            template: policyDetailsView,
            controller: policyDetailsCtrl
        },
        pcCpBuildingsAndLocations: {
            parent: wizardParentState,
            template: buildingsAndLocationsView
        },
        pcCpQuote: {
            parent: wizardParentState,
            template: quoteView,
            controller: quoteCtrl
        },
        pcCpPaymentDetails: {
            parent: wizardParentState,
            template: paymentDetailsView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-pc-cp-angular/config/RouteConfig.js
// module id = 1860
// module chunks = 0